import { TableItemActionsNew, Icons } from 'components';
import React from 'react';
const columns = (navigate, setDialog, changeStateOfBranch, changeToImprest, actionsList) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه شعبه',
    field: 'id',
    filtering: false,
    sorting: false,
    align: 'center',
  },
  {
    title: 'نام شعبه',
    field: 'name',
    filtering: false,
    sorting: false,
    align: 'center',
  },
  {
    title: 'نام و نام‌خانوادگی مالک',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => (rd?.owner ? `${rd?.owner?.name || '-'}` : '-'),
  },
  {
    title: 'وضعیت',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => (rd?.branchInfoSrv?.enable ? 'فعال' : 'غیرفعال'),
  },
  ...(actionsList['branchListTransferAction'] ||
    actionsList['branchListOperationAction'] ||
    actionsList['branchListDetailAction'] ? [{
      title: 'عملیات',
      field: 'operationSmall',
      filtering: false,
      sorting: false,
      align: 'right',
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
      render: (rd) => (
        <TableItemActionsNew
          iconButton
          startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
           title=""
          otherMenus={[
            {
              title: 'عملیات مالی',
              isShow: !!actionsList['branchListTransferAction'],
              isOpen: false,
              id: 'FinancialOperation',
              children: [
                {
                  title: 'انتقال وجه',
                  isShow: true,
                  onClick: () => {
                    navigate(
                      `/transferToBranch?username=${rd.username}&fullName=${rd.name}+&userId=${rd.userId}&userInfoType=username&userInfo=${rd.username}&transferType=wallet`,
                    );
                  },
                },
                {
                  title: 'تفویض وجه',
                  isShow: true,
                  onClick: () =>
                    navigate(`/DelegationToUser?username=${rd.username}&Type=Branch`, { state: { branchInfo: rd } }),
                },
                {
                  title: 'سقف مالی شعبه',
                  isShow: true,
                  onClick: () => navigate(`/Branch/${rd.id}/financial`, { state: rd }),
                },

              ]
            },
            {
              title: 'عملیات',
              isShow: !!actionsList['branchListOperationAction'],
              isOpen: false,
              field: 'operationSmall',
              children: [
                {
                  title: 'ویرایش',
                  isShow: true,
                  onClick: () => navigate(`/Branch/${rd.id}`, { state: rd }),
                },

                {
                  title: rd?.branchInfoSrv?.enable ? 'غیرفعال‌سازی شعبه' : 'فعال‌سازی شعبه',
                  isShow: true,
                  onClick: () => {
                    setDialog({
                      title: rd?.branchInfoSrv?.enable
                        ? ` غیرفعال‌سازی شعبه ${rd.name}`
                        : ` فعال‌سازی شعبه ${rd.name} `,
                      content: data?.branchInfoSrv?.enable ? 'با انجام این عملیات، شعبه/تنخواه گردان مورد نظر دیگر امکان برداشت وجه از حساب خود در پنل کسب و کار را نخواهد داشت. آیا از این تغییر مطمئن هستید؟' : 'آیا از انجام این عملیات اطمینان دارید؟',
                      open: true,
                      type: 'ChangeStateActionBtn',
                      onAccept: () => {
                        changeStateOfBranch(rd);
                      },
                    });
                  },
                },
                {
                  //set value false
                  otherLocation: false,
                  title: 'تغییر به تنخواه گردان',
                  isShow: true,
                  disabled: rd.imprest === true ? true : false,
                  onClick: () => {
                    setDialog({
                      title: ` تغییر شعبه ${rd.name} به تنخواه گردان`,
                      content: ' آیا از تغییر این شعبه به شعبه تنخواه گردان اطمینان دارید؟',
                      open: true,
                      type: 'ChangeStateActionBtn',
                      onAccept: () => {
                        changeToImprest(rd);
                      },
                    });
                  },
                }
              ],
            },
            {
              title: 'گزارشات',
              isShow: !!actionsList['branchListDetailAction'],
              isOpen: false,
              id: 'reports',
              children: [
                {
                  title: 'جزئيات',
                  isShow: true,
                  onClick: () => navigate(`/Branch/${rd.id}/detail`, { state: { branchInfo: rd } }),
                },

                {
                  title: 'صورت حساب',
                  isShow: true,
                  onClick: () => {
                    navigate(`/Branch/Transactions/${rd.id}`, { state: { branchInfo: rd } });
                  },
                },
              ],
            },
          ]}
        />
      ),
    }] : []),
];

const generateData = (rows, query) => {
  return rows?.map?.((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    ...row,
  }));
};

export { columns, generateData };
